import { render, staticRenderFns } from "./importExcel.vue?vue&type=template&id=32a0ff38&scoped=true"
import script from "./importExcel.vue?vue&type=script&lang=js"
export * from "./importExcel.vue?vue&type=script&lang=js"
import style0 from "./importExcel.vue?vue&type=style&index=0&id=32a0ff38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0ff38",
  null
  
)

export default component.exports